"use client";

import { trackFrontendApisClientSideErrorError } from "@faire/web-api/events/frontendApis/error/clientSideError";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { truncate } from "@faire/web/common/truncate";
import { usePathname } from "next/navigation";
import React, { useEffect } from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SearchPageErrorHandler } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ErrorBoundary";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  SearchPageData,
  SearchPageDataContextProvider,
} from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageDataContext";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  SearchPageFiltersData,
  SearchPageFiltersDataContextProvider,
} from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageFiltersDataContext";

const Error = ({ error }: { error: Error }) => {
  const pathname = usePathname();

  useEffect(() => {
    // since DD RUM samples errors, we need to track errors using PETE as well
    trackFrontendApisClientSideErrorError(
      // truncatePath was used to ensure error message is not too long
      // because PETE has a limit of characters
      truncate(
        `${error.message ?? "Unknown error"}\nStack: ${
          error.stack ?? "No stack available"
        }`,
        255
      ),
      "DISCOVER_RSC",
      pathname,
      getGlobalProperty("processingServer")
    );
  }, [error, pathname]);

  // This is a hack to handle the error managed by NextJS and pass it to the Search Page data providers
  return (
    <SearchPageDataContextProvider
      searchPageData={
        {
          error,
        } as SearchPageData
      }
    >
      <SearchPageFiltersDataContextProvider
        searchPageFiltersData={{} as SearchPageFiltersData}
      >
        <SearchPageErrorHandler />
      </SearchPageFiltersDataContextProvider>
    </SearchPageDataContextProvider>
  );
};

export default Error;
